export type PlaidConnectErrorToast = {
  description?: string;
  title: string;
};

export function plaidConnectErrorToast(
  message: string,
): PlaidConnectErrorToast {
  if (/authenticator app/i.test(message) || /\bMFA\b/i.test(message)) {
    return { title: message };
  }

  if (/save/i.test(message)) {
    return {
      description: "No bank data was changed. Try again in a moment.",
      title: "Couldn't save the bank connection",
    };
  }

  return {
    description: "Plaid did not open. Try again in a moment.",
    title: "Couldn't start the bank connection",
  };
}
